import { Head, usePage } from '@inertiajs/react'
import {
  Badge,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import SettingsForm from '@/components/SettingsForm'
import type { ProjectSettingsPageProps } from '@/types'

export default function ProjectSettings() {
  const {
    project,
    settings,
    sensitive_configured,
    org_settings,
    org_sensitive_configured,
    settings_registry,
  } = usePage<ProjectSettingsPageProps>().props

  return (
    <>
      <Head title={`${project.name} - Settings`} />

      <Container size="xl" py="md">
        <Stack gap="xl">
          <Group justify="space-between" align="flex-start">
            <div>
              <Title order={2}>Project Settings</Title>
              <Text c="dimmed" mt={4}>{project.name}</Text>
            </div>
            <Badge variant="light" size="lg">{project.slug}</Badge>
          </Group>

          <Text size="sm" c="dimmed">
            Settings defined here override organization-level defaults for this project.
            Leave a field empty to inherit from the organization.
          </Text>

          <SettingsForm
            registry={settings_registry}
            settings={settings}
            sensitiveConfigured={sensitive_configured}
            submitUrl={`/projects/${project.id}/settings`}
            submitLabel="Save Project Settings"
            orgSettings={org_settings}
            orgSensitiveConfigured={org_sensitive_configured}
          />
        </Stack>
      </Container>
    </>
  )
}
